import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { MobileClientPanel } from './components/MobileClientPanel';
import { TrustMiniSection } from './components/TrustMiniSection';
import { ElegeCaminoSection } from './components/ElegeCaminoSection';
import { WhatsAppTestimonialsSection } from './components/WhatsAppTestimonialsSection';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { PortfolioSection } from './components/PortfolioSection';
import { PortfolioCTASection } from './components/PortfolioCTASection';
import { FAQSection } from './components/FAQSection';
import { ServiciosComplementariosSection } from './components/ServiciosComplementariosSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2433320707143614');
      fbq('track', 'PageView');
      fbq('track', 'ViewContent', {
        content_name: 'Inkova Services',
        content_category: 'Business Consulting',
        currency: 'USD',
        value: 0
      });
    `;
    document.head.appendChild(script);
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2433320707143614&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
    // Fire Lead event when user clicks any WhatsApp button or CTA
    const handleLeadClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target) return;
      const el = target.closest('a[href*="wa.me"], a[href*="whatsapp.com"], a[href*="inkovacreation.store"]') as HTMLAnchorElement | null;
      if (!el) return;
      const fbq = (window as any).fbq;
      if (typeof fbq === 'function') {
        fbq('track', 'Lead', {
          content_name: el.textContent?.trim().slice(0, 80) || 'CTA Click',
          content_category: el.href.includes('wa.me') || el.href.includes('whatsapp.com') ? 'WhatsApp Contact' : 'Purchase Intent',
          currency: 'USD',
          value: 0
        });
      }
    };
    document.addEventListener('click', handleLeadClick);
    return () => {
      document.removeEventListener('click', handleLeadClick);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-inkova-accent selection:text-inkova-primary" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustMiniSection data-id="element-4" />
        <MobileClientPanel data-id="element-5" />
        <ElegeCaminoSection data-id="element-6" />
        <WhatsAppTestimonialsSection data-id="element-7" />
        <PortfolioSection data-id="element-8" />
        <PortfolioCTASection data-id="element-9" />
        <ServicesSection data-id="element-10" />
        <AboutSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <ServiciosComplementariosSection data-id="element-13" />
        <CTASection data-id="element-14" />
      </main>
      <Footer data-id="element-15" />
      <WhatsAppFloat data-id="element-16" />
    </div>;
}